import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface RoundedTabsProps {
  $active?: boolean;
}

export const RoundedTabs = styled.div<RoundedTabsProps>`
  width: 167px;
  height: 48px;
  border-radius: 32px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0 0;
  flex-shrink: 0;
  color: ${({ $active, theme }) => ($active ? theme.tabs.rounded.activeColor : theme.tabs.rounded.inactiveColor)};
  background: ${({ $active, theme }) =>
    $active ? theme.tabs.rounded.activeBackground : theme.tabs.rounded.inactiveBackground};
  box-shadow: 0 2px 12px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  cursor: pointer;
  @media ${({ theme }) => theme.device.mobile} {
    width: calc(50% - 14px);
  }
`;
